import React from 'react'
import fastFood from '../../assets/fastfood.svg'
import { Map, GoogleApiWrapper } from 'google-maps-react';
import { Link } from 'react-router-dom'
import styles from './DeliveryInfo.module.css'

const DeliveryInfo = (props) => {

    const mapStyles = {
        width: '100%',
        height: '100%'
    };
    return (
        <div className={styles.container}>
            <div className={styles.box}></div>
            <header>
                <div className={styles.topHeader}>
                    <Link to="/new-deliveries">
                        <i className={styles.backIcon + " fas fa-chevron-left"}></i>
                    </Link>
                    <h3>Order ID 114258</h3>
                </div>
                <div className={styles.bottomHeader}>
                    <div className={styles.top}>
                        <div className={styles.topLeft}>
                            <img src={fastFood} alt="fast-food" />
                            <div className={styles.name}>
                                <h3>Courier</h3>
                                <small>Economy Delivery</small>
                            </div>
                        </div>
                        <div className={styles.deliveryStatus}>
                            <button>Marked Picked</button>
                        </div>
                    </div>
                </div>
            </header>
            <main>
                <div className={styles.mapsContainer}>
                    <Map
                        google={props.google}
                        zoom={14}
                        style={mapStyles}
                        initialCenter={
                            {
                                lat: -1.2884,
                                lng: 36.8233
                            }
                        }
                    />
                </div>

                <div className={styles.content}>
                    <div className={styles.dialContainer}>
                        <div className={styles.dialInfo}>
                            <h2>Get Direction</h2>
                            <small>Open google map</small>
                        </div>
                        <i className="fas fa-location-arrow"></i>
                    </div>
                    <div className={styles.directionsContainer}>
                        <div className={styles.iconsContainer}>
                            <i className={styles.icon + " fas fa-map-marker-alt"}></i>
                            <span className={styles.line}></span>
                            <i className={styles.icon + " fas fa-location-arrow"}></i>
                        </div>
                        <div className={styles.places}>
                            <div className={styles.place}>
                                <div className={styles.placeText}>
                                    <small>Walmart</small>
                                    <h2>Emili Williamson</h2>
                                    <p>128 Mott St. New York, NY 10013, United States.</p>
                                </div>
                                <i className={styles.icon + " fas fa-phone"}></i>
                            </div>
                            <div className={styles.place}>
                                <div className={styles.placeText}>
                                    <small>City Garden</small>
                                    <h2>Samantha Williamson</h2>
                                    <p>128 Mott St. New York, NY 10013, United States.</p>
                                </div>
                                <i className={styles.icon + " fas fa-phone"}></i>
                            </div>
                        </div>
                    </div>
                    <div className={styles.infoContainer}>
                        <div className={styles.box_2}>
                            <small>Courier Type</small>
                            <p>Box Courier</p>
                        </div>
                        <div className={styles.box_2}>
                            <small>Frangible</small>
                            <p>Yes</p>
                        </div>
                        <div className={styles.box_2}>
                            <small>Height Weight Length</small>
                            <p>60 x 75 x 124 (cm)</p>
                        </div>
                        <div className={styles.box_2}>
                            <small>Weight</small>
                            <p>10 kg</p>
                        </div>
                        <div className={styles.box_2}>
                            <small>Courier Info</small>
                            <p>Birthday Gift containing flower Vaas, Carry carefully as it is frangible.</p>
                        </div>
                    </div>

                    <div className={styles.total}>
                        <div className={styles.totalLeft}>
                            <h2>Economy Delivery</h2>
                            <small>Payment via Cash on Pickup</small>
                        </div>
                        <div className={styles.totalRight}>
                            <h2>$8.60</h2>
                        </div>
                    </div>

                </div>


            </main>
        </div>
    )
}

export default GoogleApiWrapper({
    apiKey: "AIzaSyCbGCVUGEoqvURirLROMcMTVXHS0XWlJVk"
})(DeliveryInfo);